import React, { useState, useRef, useEffect } from "react";
import { i18n } from "../../translate/i18n";

const ChevronDownIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

const CheckIcon = ({ className }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleToggle = (queueId) => {
    const newSelected = selectedQueueIds.includes(queueId)
      ? selectedQueueIds.filter((id) => id !== queueId)
      : [...selectedQueueIds, queueId];
    onChange(newSelected);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between gap-2 px-3 py-1.5 text-sm border border-dark-300 dark:border-dark-600 rounded-lg bg-white dark:bg-dark-800 text-dark-700 dark:text-dark-200 hover:bg-dark-50 dark:hover:bg-dark-700 transition-colors min-w-[120px]"
      >
        <span className="truncate">{i18n.t("ticketsQueueSelect.placeholder")}</span>
        <ChevronDownIcon className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 z-50 min-w-[180px] bg-white dark:bg-dark-800 border border-dark-200 dark:border-dark-700 rounded-lg shadow-lg py-1 max-h-60 overflow-y-auto">
          {userQueues?.length > 0 ? (
            userQueues.map((queue) => {
              const isSelected = selectedQueueIds.includes(queue.id);
              return (
                <button
                  key={queue.id}
                  type="button"
                  onClick={() => handleToggle(queue.id)}
                  className="w-full flex items-center gap-2 px-3 py-2 text-sm text-dark-700 dark:text-dark-200 hover:bg-dark-100 dark:hover:bg-dark-700 transition-colors"
                >
                  <div
                    className={`w-4 h-4 border-2 rounded flex items-center justify-center transition-colors ${
                      isSelected
                        ? "border-transparent"
                        : "border-dark-300 dark:border-dark-600"
                    }`}
                    style={{
                      backgroundColor: isSelected ? queue.color : "transparent",
                      borderColor: isSelected ? queue.color : undefined,
                    }}
                  >
                    {isSelected && <CheckIcon className="w-3 h-3 text-white" />}
                  </div>
                  <span className="truncate">{queue.name}</span>
                </button>
              );
            })
          ) : (
            <div className="px-3 py-2 text-sm text-dark-500 dark:text-dark-400">
              Nenhuma fila disponível
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TicketsQueueSelect;
